export enum DataDicoRole {
  admin = 'datadico-admin',
  edit = 'datadico-edit',
  consult = 'datadico-consult',
}
